import _regeneratorRuntime from "/home/thrstn/Projects/keakort/node_modules/@babel/runtime-corejs2/regenerator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/thrstn/Projects/keakort/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import axios from 'axios';
export function updateAPIAccessToken(context, payload) {
  axios.defaults.headers.common['X-Access-Token'] = payload;
}
export function getCurrentPosition(_x) {
  return _getCurrentPosition.apply(this, arguments);
}

function _getCurrentPosition() {
  _getCurrentPosition = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
    var commit;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            commit = _ref.commit;
            return _context2.abrupt("return", new Promise(function (resolve, reject) {
              navigator.geolocation.getCurrentPosition( /*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(success) {
                  var _success$coords, latitude, longitude;

                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _success$coords = success.coords, latitude = _success$coords.latitude, longitude = _success$coords.longitude;
                          _context.next = 3;
                          return commit('updateCurrentPosition', {
                            latitude: latitude,
                            longitude: longitude
                          });

                        case 3:
                          resolve(true);

                        case 4:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x4) {
                  return _ref6.apply(this, arguments);
                };
              }(), function (error) {
                reject(error);
              }, {
                enableHighAccuracy: true,
                timeout: 500
              });
            }));

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getCurrentPosition.apply(this, arguments);
}

export function fetchPageFromAPI(_x2, _x3) {
  return _fetchPageFromAPI.apply(this, arguments);
}

function _fetchPageFromAPI() {
  _fetchPageFromAPI = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref2, codename) {
    var commit, response, payload;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            commit = _ref2.commit;
            response = '';

            if (!(codename === 'terms')) {
              _context3.next = 8;
              break;
            }

            _context3.next = 5;
            return axios.get('/page/skilmalar-kea-kortsins');

          case 5:
            response = _context3.sent;
            _context3.next = 11;
            break;

          case 8:
            _context3.next = 10;
            return axios.get("/page/ui_keakort-".concat(codename));

          case 10:
            response = _context3.sent;

          case 11:
            if (response.status === 200) {
              payload = response.data;
              commit('updatePage', {
                codename: codename,
                payload: payload
              });
            }

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _fetchPageFromAPI.apply(this, arguments);
}

export function blockInteraction(_ref3) {
  var commit = _ref3.commit;
  commit('blockInteraction');
}
export function allowInteraction(_ref4) {
  var commit = _ref4.commit;
  commit('allowInteraction');
}
export function setSavedPosition(_ref5, payload) {
  var commit = _ref5.commit;
  commit('setSavedPosition', payload);
}